import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
  IStatutoryBalances,
  IStatutoryPayment,
  IStatutoryBalancesParams,
  IStatutoryPaymentForm,
  IStatutoryPaymentHistoryParams,
  IStatutoryBalancesResponse,
  IStatutoryPaymentResponse,
  IStatutoryPaymentHistoryResponse
} from "../../utils/statutorySettlement.types";

/**
 * Fetch statutory balances (PF, ESI, PT) for a period
 */
export const fetchStatutoryBalances = createAsyncThunk(
  'statutorySettlement/fetchBalances',
  async (params: IStatutoryBalancesParams): Promise<IStatutoryBalances> => {
    const response = await axios.get<IStatutoryBalancesResponse>(
      `/api/v1/statutory-settlement/balances`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Record statutory payment to government
 */
export const recordStatutoryPayment = createAsyncThunk(
  'statutorySettlement/recordPayment',
  async (paymentData: IStatutoryPaymentForm): Promise<IStatutoryPayment> => {
    const response = await axios.post<IStatutoryPaymentResponse>(
      `/api/v1/statutory-settlement/payment`,
      paymentData
    );
    return response.data.data;
  }
);

/**
 * Fetch statutory payment history
 */
export const fetchStatutoryPaymentHistory = createAsyncThunk(
  'statutorySettlement/fetchHistory',
  async (params?: IStatutoryPaymentHistoryParams): Promise<IStatutoryPayment[]> => {
    const response = await axios.get<IStatutoryPaymentHistoryResponse>(
      `/api/v1/statutory-settlement/payment-history`,
      { params }
    );
    return response.data.data;
  }
);
